{
  "loading": "Betöltés folyamatban…",
  "placeholder": "Válasszon egy opciót…"
}
